import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useAPI } from 'global'
import { OpenBeforeAlarmDuration, OpenAlarmDuration } from 'enums'
import { Button, Select } from 'components'

export default function LockConfigsEdit(props) {
  const { t } = useTranslation(null, { useSuspense: false })
  const { config, onFinish } = props
  const api = useAPI()

  const beforeDurSelect = useRef()
  const alarmDurSelect = useRef()

  const defaultBeforeDur = config.defaultConfiguration.durationBeforeAlarm
  const defaultAlarmDur = config.defaultConfiguration.alarmDuration

  const onSave = async () => {
    const newBeforeDur = Number(beforeDurSelect.current?.value || 0)
    const newAlarmDur = Number(alarmDurSelect.current?.value || 0)
    const cur = config.defaultConfiguration
    if (cur?.durationBeforeAlarm == newBeforeDur && cur?.alarmDuration == newAlarmDur) {
      if (onFinish) onFinish()
      return // Nothing's changed here, so just return
    }

    const newConfig = {
      ...config,
      defaultConfiguration: {
        durationBeforeAlarm: newBeforeDur,
        alarmDuration: newAlarmDur,
      },
    }
    const res = await api.saveOrgConfig(newConfig).then(c => {
      toast.success(t('organizationDetails.lockConfigSaved'))
      return c
    }).catch(r => {
      const e = t('organizationDetails.lockConfigSaveFailed')
      console.error(e, r)
      toast.error(e)
    })
    if (onFinish) onFinish(res)
  }

  const beforeDurOptions = Object.keys(OpenBeforeAlarmDuration).map(k => {
    return <option key={k} value={OpenBeforeAlarmDuration[k]}>{t(`deviceConfig.${k}`)}</option>
  })
  const alarmDurOptions = Object.keys(OpenAlarmDuration).map(k => {
    return <option key={k} value={OpenAlarmDuration[k]}>{t(`deviceConfig.${k}`)}</option>
  })

  return (
    <div className="org-lock-configs-edit-comp">
      <Select label={t('deviceConfig.openBeforeAlarmDur')} ref={beforeDurSelect} defaultValue={defaultBeforeDur}>{beforeDurOptions}</Select>
      <Select label={t('deviceConfig.openAlarmDur')} ref={alarmDurSelect} defaultValue={defaultAlarmDur}>{alarmDurOptions}</Select>
      <Button onClick={onSave}>{t('form.save')}</Button>
    </div>
  )
}
